import { Chip, Grid, Typography } from "@material-ui/core";
import { useStyles } from "../about-me-mentor.styles";
interface ExpertisesMentorProps {
  data?: string[];
}
function ExpertisesMentor({ data }: ExpertisesMentorProps) {
  const classes = useStyles();
  return (
    <Grid container spacing={3}>
      <Grid item container spacing={1}>
        <Typography className={classes.title}>Expertise</Typography>
      </Grid>
      <Grid item container justifyContent="center" spacing={1}>
        {data && data.length ? (
          data.map((expertise, index) => {
            return (
              <Grid item key={index}>
                <Chip
                  key={index}
                  label={expertise}
                  className={classes.customChipStyle}
                  data-testid={expertise}
                />
              </Grid>
            );
          })
        ) : (
          <Grid item spacing={1}>
            <Typography>No expertises found.</Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
export default ExpertisesMentor;
